
export default function ContactContent() {
  const contactItems = [
    {
      icon: 'ri-map-pin-2-line',
      label: 'Address',
      value: '176 Millicent Grove, London N13 6HS',
      href: 'https://www.google.com/maps/search/176+Millicent+Grove+London+N13+6HS',
    },
    {
      icon: 'ri-phone-line',
      label: 'Phone',
      value: '020 3441 9463',
      href: 'tel:02034419463',
    },
    {
      icon: 'ri-mail-line',
      label: 'Email',
      value: 'thenorthpiano@googlemail.com',
      href: 'mailto:thenorthpiano@googlemail.com',
    },
    {
      icon: 'ri-global-line',
      label: 'Website',
      value: 'www.pianomoveteam.co.uk',
      href: 'https://www.pianomoveteam.co.uk',
    },
  ];

  const hours = [
    { day: 'Monday – Friday', time: '08:30 – 18:00', open: true },
    { day: 'Saturday', time: '08:30 – 15:00', open: true },
    { day: 'Sunday', time: 'Closed', open: false },
  ];

  const services = [
    {
      icon: 'ri-truck-line',
      title: 'Piano Removals London',
      description: 'Professional piano removal across all London boroughs. Fully insured, specialist team.',
      href: '/piano-removals-london',
    },
    {
      icon: 'ri-music-2-line',
      title: 'Grand Piano Removal',
      description: 'Expert grand piano dismantling, moving and reassembly by trained specialists.',
      href: '/grand-piano-removal-london',
    },
    {
      icon: 'ri-layout-column-line',
      title: 'Upright Piano Removal',
      description: 'Safe and efficient upright piano moves — stairs, tight spaces, no problem.',
      href: '/upright-piano-removal-london',
    },
    {
      icon: 'ri-store-2-line',
      title: 'Piano Storage London',
      description: 'Secure, climate-controlled piano storage for short and long-term needs.',
      href: '/piano-storage-london',
    },
    {
      icon: 'ri-map-pin-2-line',
      title: 'Piano Movers London',
      description: 'Trusted local piano movers with over 30,000 moves completed since 2007.',
      href: '/piano-movers-london',
    },
    {
      icon: 'ri-money-pound-circle-line',
      title: 'Piano Removal Cost',
      description: 'Transparent, fixed-price quotes. See our full pricing guide for London.',
      href: '/piano-removal-cost-london',
    },
  ];

  return (
    <section className="py-16 px-6 bg-[#f5f5f0]">
      <div className="max-w-6xl mx-auto">

        {/* Intro */}
        <div className="max-w-3xl mx-auto text-center mb-14">
          <h2 className="text-3xl md:text-4xl font-serif font-bold mb-5 text-[#0e0d0b]">
            Get in Touch
          </h2>
          <p className="text-[#4a4a44] text-lg leading-relaxed">
            London&apos;s specialist piano removal team — established 2007, over 30,000 moves completed. Call us or email for a free, fixed-price quote with no obligation.
          </p>
        </div>

        {/* Top row: Contact details + Opening hours */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-8">

          {/* Contact Details */}
          <div className="bg-[#0e0d0b] rounded-lg p-8">
            <h3 className="text-[#f5f5f0] font-serif font-bold text-xl mb-6">Contact Details</h3>
            <div className="flex flex-col gap-5">
              {contactItems.map((item) => (
                <a
                  key={item.label}
                  href={item.href}
                  target={item.label === 'Website' || item.label === 'Address' ? '_blank' : undefined}
                  rel={item.label === 'Website' || item.label === 'Address' ? 'noopener noreferrer nofollow' : undefined}
                  className="flex items-center gap-4 group cursor-pointer"
                >
                  <div className="w-11 h-11 flex items-center justify-center rounded-lg bg-[#c9a84c]/20 flex-shrink-0">
                    <i className={`${item.icon} text-lg text-[#c9a84c]`} aria-hidden="true"></i>
                  </div>
                  <div>
                    <p className="text-[#8a8a84] text-xs uppercase tracking-wider mb-0.5">{item.label}</p>
                    <p className="text-[#f5f5f0] text-sm font-semibold group-hover:text-[#c9a84c] transition-colors">
                      {item.value}
                    </p>
                  </div>
                </a>
              ))}
            </div>

            {/* Insurance badge */}
            <div className="mt-8 bg-[#c9a84c]/10 border border-[#c9a84c]/25 rounded-lg p-4 flex items-start gap-3">
              <div className="w-9 h-9 flex items-center justify-center flex-shrink-0">
                <i className="ri-shield-check-line text-xl text-[#c9a84c]" aria-hidden="true"></i>
              </div>
              <div>
                <p className="text-[#f5f5f0] font-semibold text-sm">Fully Insured to £5 Million</p>
                <p className="text-[#8a8a84] text-xs mt-0.5 leading-relaxed">
                  Established 2007. Over 30,000 piano moves completed across London and the UK.
                </p>
              </div>
            </div>
          </div>

          {/* Opening Hours */}
          <div className="bg-white rounded-lg border border-[#e8e8e2] p-8 shadow-sm">
            <h3 className="text-[#0e0d0b] font-serif font-bold text-xl mb-2">Opening Hours</h3>
            <p className="text-[#8a8a84] text-sm mb-7">We&apos;re available to take your call or enquiry during these hours</p>
            <div className="flex flex-col gap-4">
              {hours.map((h) => (
                <div key={h.day} className="flex items-center justify-between py-3 border-b border-[#f0f0ea] last:border-0">
                  <div className="flex items-center gap-3">
                    <div className={`w-2 h-2 rounded-full flex-shrink-0 ${h.open ? 'bg-emerald-500' : 'bg-[#d8d8d2]'}`}></div>
                    <span className="text-[#1a1916] font-medium text-sm">{h.day}</span>
                  </div>
                  <span className={`text-sm font-semibold ${h.open ? 'text-[#0e0d0b]' : 'text-[#a0a09a]'}`}>
                    {h.time}
                  </span>
                </div>
              ))}
            </div>

            {/* CTA */}
            <div className="mt-8 flex flex-col gap-3">
              <a
                href="tel:02034419463"
                className="flex items-center justify-center gap-2 bg-[#c9a84c] hover:bg-[#b8973d] text-[#0e0d0b] px-6 py-3.5 rounded-md text-sm font-bold transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-phone-line text-base" aria-hidden="true"></i>
                Call 020 3441 9463
              </a>
              <a
                href="mailto:thenorthpiano@googlemail.com"
                className="flex items-center justify-center gap-2 bg-[#0e0d0b] hover:bg-[#1e1d1b] text-[#f5f5f0] px-6 py-3.5 rounded-md text-sm font-bold transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-mail-line text-base" aria-hidden="true"></i>
                Email Us
              </a>
            </div>
          </div>
        </div>

        {/* Map */}
        <div className="rounded-lg overflow-hidden border border-[#e8e8e2] shadow-sm mb-8">
          <div className="bg-[#0e0d0b] px-6 py-4 flex items-center gap-3">
            <div className="w-8 h-8 flex items-center justify-center">
              <i className="ri-map-pin-line text-lg text-[#c9a84c]" aria-hidden="true"></i>
            </div>
            <div>
              <p className="text-[#f5f5f0] font-semibold text-sm">Our Location</p>
              <p className="text-[#8a8a84] text-xs">176 Millicent Grove, London N13 6HS</p>
            </div>
          </div>
          <iframe
            title="Piano Movers UK — 176 Millicent Grove, London N13 6HS"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2477.3!2d-0.1!3d51.62!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x48761b0e0e0e0e0f%3A0x0!2s176+Millicent+Grove%2C+London+N13+6HS!5e0!3m2!1sen!2suk!4v1700000000000"
            width="100%"
            height="380"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>

        {/* Services Grid */}
        <div className="bg-[#0e0d0b] rounded-lg p-8 mb-8">
          <h3 className="text-[#f5f5f0] font-serif font-bold text-xl mb-1">Our Services</h3>
          <p className="text-[#8a8a84] text-sm mb-7">Click any service to learn more</p>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {services.map((service) => (
              <a
                key={service.href}
                href={service.href}
                className="flex items-start gap-4 group bg-white/5 hover:bg-[#c9a84c]/15 border border-white/10 hover:border-[#c9a84c]/40 rounded-lg p-5 transition-all cursor-pointer"
              >
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-[#c9a84c]/20 flex-shrink-0 mt-0.5">
                  <i className={`${service.icon} text-base text-[#c9a84c]`} aria-hidden="true"></i>
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-[#f5f5f0] text-sm font-semibold group-hover:text-[#c9a84c] transition-colors mb-1">
                    {service.title}
                  </p>
                  <p className="text-[#8a8a84] text-xs leading-relaxed">{service.description}</p>
                </div>
              </a>
            ))}
          </div>
        </div>

        {/* Internal links */}
        <div className="bg-[#c9a84c]/10 p-8 rounded-lg border border-[#c9a84c]/20">
          <p className="text-lg text-[#1a1916]">
            Looking for pricing information before you get in touch? Visit our{' '}
            <a href="/piano-removal-cost-london" className="text-[#c9a84c] hover:text-[#b8973d] font-semibold underline">
              piano removal cost London
            </a>{' '}
            guide, or learn more about our{' '}
            <a href="/piano-removals-london" className="text-[#c9a84c] hover:text-[#b8973d] font-semibold underline">
              piano removals London
            </a>{' '}
            service.
          </p>
        </div>

      </div>
    </section>
  );
}
